'use client';

import { usePathname } from '@framework/next/navigation';
import { Tracer } from './../react/Tracer';

const PageLoadInstrumentation = ({ children }: React.PropsWithChildren) => {
  const pathname = usePathname();

  return (
    <Tracer.StartActiveSpan
      name="page.load"
      options={ {
        attributes: {
          page: pathname,
        },
      } }
    >
      { children }
    </Tracer.StartActiveSpan>
  );
};

export default PageLoadInstrumentation;
